export default __webpack_public_path__ + "static/media/money-back.7ccbaddb.png";